// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3H2JA","label":"styles_label__b1slS"};